import React, { useState } from "react";
import { useField } from "formik";
import Styles from "../signup/SignupForm.module.css";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";


const PasswordCheck = ({ label, ...props }) => {
	const [field, meta] = useField(props);
	const [showPassword, setShowPassword] = useState(false);

	return (
		<div className={Styles.customInput}>
			<label>{label}</label>
			<div className={Styles.flexSize}>
				<input
					{...field}
					{...props}
					type={showPassword ? "text" : "password"}
					className={
						meta.touched && meta.error
							? Styles.inputError
							: ""
					}
				/>
				{showPassword ? (
					<VisibilityOffIcon
						className={Styles.passwordVisibilityIcon}
						onClick={() => setShowPassword(!showPassword)}
					/>
				) : (
					<VisibilityIcon
						className={Styles.passwordVisibilityIcon}
						onClick={() => setShowPassword(!showPassword)}
					/>
				)}
			</div>
			{meta.touched && meta.error && (
				<div className={Styles.error}>{meta.error}</div>
			)}
		</div>
	);
};

export default PasswordCheck;
